import BSN from "bootstrap.native"

document.addEventListener("DOMContentLoaded", () => {
  BSN.initCallback()
})
document.addEventListener("turbo:load", () => {
  BSN.initCallback()
})
